import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';
import { SubscriptionFacadeService } from '../../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'company-profile-form',
    templateUrl: './company-profile-form.component.html',
    styleUrls: ['./company-profile-form.component.scss'],
    standalone: false
})
export class CompanyProfileFormComponent
  extends EaSubscriptionBuilder
  implements OnInit, AfterViewInit
{
  @Input() col: number = 6;

  countries = [];
  companyActivitySectors = [];
  companyLegalForms = [
    { id: 'unknow', label: 'Inconnu' },

    { id: 'ei', label: 'E.I.' },
    { id: 'eirl', label: 'E.I.R.L.' },
    { id: 'micro_entreprise', label: 'Micro-entreprise' },
    { id: 'auto_entrepreneur', label: 'Auto-entrepreneur' },
    { id: 'agent_commercial', label: 'Agent-commercial' },

    { id: 'sa', label: 'S.A.' },
    { id: 'sas', label: 'S.A.S.' },
    { id: 'sasu', label: 'S.A.S.U.' },
    { id: 'sarl', label: 'S.A.R.L.' },
    { id: 'eurl', label: 'E.U.R.L.' },
    { id: 'snc', label: 'S.N.C.' },
    { id: 'scs', label: 'S.C.S.' },
    { id: 'sca', label: 'S.C.A.' },

    { id: 'sc', label: 'S.C.' },
    { id: 'sci', label: 'S.C.I.' },
    { id: 'scm', label: 'S.C.M.' },
    { id: 'scp', label: 'S.C.P.' },
    { id: 'scea', label: 'S.C.E.A.' },
    { id: 'gfa', label: 'G.F.A.' },

    { id: 'earl', label: 'E.A.R.L.' },
    { id: 'gaec', label: 'G.A.E.C.' },

    { id: 'selarl', label: 'S.E.L.A.R.L.' },
    { id: 'selas', label: 'S.E.L.A.S.' },
    { id: 'selafa', label: 'S.E.L.A.F.A.' },
    { id: 'selca', label: 'S.E.L.C.A.' },

    { id: 'scop', label: 'S.C.O.P.' },
    { id: 'scic', label: 'S.C.I.C.' },
    { id: 'sce', label: 'S.C.E.' },

    { id: 'association_1901', label: 'Association loi 1901' },
    { id: 'association_utilite_publique', label: "Association reconnue d'utilité publique" },
    { id: 'association_cultuelle', label: 'Association cultuelle' },
    { id: 'fondation', label: 'Fondation' },
    { id: 'fonds_dotation', label: 'Fonds de dotation' },

    { id: 'gie', label: 'G.I.E.' },
    { id: 'geie', label: 'G.E.I.E.' },
    { id: 'epic', label: 'E.P.I.C.' },
    { id: 'epa', label: 'E.P.A.' },
    { id: 'sem', label: 'S.E.M.' },
    { id: 'spl', label: 'S.P.L.' },
    { id: 'se', label: 'S.E.' },
  ];
  companyTaxSystems = [];
  representativeOptions = [
    { id: 'CO_GERANT', value: 'Co-gérant' },
    { id: 'ASSOCIATE', value: 'Associé' },
    { id: 'DIRECTEUR_GENERAL', value: 'Directeur général' },
    { id: 'GERANT', value: 'Gérant' },
    { id: 'PRESIDENT', value: 'Président' },
  ];
  parameters = {};
  organizationId: number;
  cristalisOrganizationId: number = 251251251;
  isCristalisOrganization: boolean;
  sessionConsultant: boolean;
  taxSystems: any[] = [
    { id: 'NI', label: 'Non imposable' },
    { id: 'IR', label: 'IR' },
    { id: 'IS', label: 'IS' },
    { id: 'AUTRE', label: 'Autre' },
  ];

  constructor(
    private referenceDao: ReferenceDao,
    protected formConstructor: PrFormConstructor,
    private cd: ChangeDetectorRef,
    private attributionDao: AttributionDao,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
    // new add
  }
  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }
  displayOwner(owner) {}

  ngOnInit() {
    this.attributionDao.getOrganization().subscribe((data: any) => {
      this.isCristalisOrganization = this.cristalisOrganizationId === data.id;
    });
    this.sessionConsultant =
      !!this.subscriptionFacade?.getPledge() &&
      !!this.subscriptionFacade?.getUser()?.sessionConsultant;

    this.parameters = this.subscriptionFacade.getPledge()?.parameters;

    combineLatest([
      this.referenceDao.getCountries(),
      this.referenceDao.getCompanyActivitySectors(),
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([countries, companyActivitySectors]) => {
        this.countries = countries;
        this.companyActivitySectors = companyActivitySectors;
      });
    this.subscriptionFacade.initForm(this, {
      isCristalisOrganization: this.isCristalisOrganization,
      sessionConsultant: this.sessionConsultant,
    });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
